import { render, staticRenderFns } from "./TaEmployeeGroupAdd.vue?vue&type=template&id=24b85a18"
import script from "./TaEmployeeGroupAdd.vue?vue&type=script&lang=js"
export * from "./TaEmployeeGroupAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports